export enum ECareerBannerType {
  top = 'CAREER_TOP_BANNER',
  bottom = 'CAREER_BOTTOM_BANNER',
  about_us = 'CAREER_ABOUT_US',
}
interface Media {
  id: number
  url: string
  name: string
  path: string
  type: string
  bucket: string
  userId: number
  baseUrl: string
  groupId: number | null
  category: string | null
  createdAt: string // ISO date string
  signedUrl: string
  updatedAt: string // ISO date string
  cloudfrontUrl: string
}

interface MetaData {
  layout: string
  position: string
  textColor: string
}

interface DownloadMetaData {
  buttonLink: string
  buttonLink2: string
}

export interface IEvolveDownloadData {
  id: number
  no: number
  name: string | null
  nameInDutch: string | null
  title: string
  titleInDutch: string
  subTitle: string | null
  subTitleInDutch: string | null
  content: string
  subContent: string | null
  contentInDutch: string
  subContentInDutch: string | null
  milestone: string | null
  type: 'EVOLVE_DOWNLOAD'
  media: Media
  mediaId: number | null
  mediaMobile: Media
  mediaMobileId: number | null
  thumbnail: Media | null
  thumbnailId: number | null
  thumbnailMobile: Media | null
  thumbnailMobileId: number | null
  mediaDescription: string | null
  mediaDescriptionInDutch: string | null
  metaData: DownloadMetaData
  mediaTitle: string | null
  createdAt: string // ISO date string
  updatedAt: string // ISO date string
}

export interface ICareerBannerData {
  id: number
  no: number
  name: string | null
  nameInDutch: string | null
  title: string
  titleInDutch: string
  subTitle: string | null
  subTitleInDutch: string | null
  content: string
  subContent: string | null
  contentInDutch: string
  subContentInDutch: string | null
  milestone: string | null
  type: string
  media: Media
  mediaId: number | null
  mediaMobile: Media
  mediaMobileId: number | null
  thumbnail: Media | null
  thumbnailId: number | null
  thumbnailMobile: Media | null
  thumbnailMobileId: number | null
  mediaDescription: string | null
  mediaDescriptionInDutch: string | null
  metaData: MetaData
  mediaTitle: string | null
  createdAt: string // ISO date string
  updatedAt: string // ISO date string
}

export interface IEvolveFeatureData {
  id: number
  no: number
  name: string | null
  nameInDutch: string | null
  title: string
  titleInDutch: string
  subTitle: string | null
  subTitleInDutch: string | null
  content: string
  subContent: string | null
  contentInDutch: string
  subContentInDutch: string | null
  milestone: string | null
  type: 'EVOLVE_FEATURE'
  media: Media
  mediaId: number | null
  mediaMobile: Media
  metaData: MetaData
  mediaTitle: string | null
  createdAt: string // ISO date string
  updatedAt: string // ISO date string
}
// member use item
export interface ICareer {
  id: number
  no: number
  name: string | null
  nameInDutch: string | null
  title: string | null
  titleInDutch: string | null
  subTitle: string | null
  subTitleInDutch: string | null
  content: string | null
  subContent: string | null
  contentInDutch: string | null
  subContentInDutch: string | null
  milestone: string | null
  type: string
  media: Media | null
  mediaId: number | null
  mediaMobile: Media | null
  mediaMobileId: number | null
  thumbnail: Media | null
  thumbnailId: number | null
  thumbnailMobile: Media | null
  thumbnailMobileId: number | null
  mediaDescription: string | null
  mediaDescriptionInDutch: string | null
  metaData: string | null
  mediaTitle: string | null
  createdAt: string
  updatedAt: string
}

//seo
interface MetaData {
  keywords: string | null
  canonical: string | null
  metaImage: string | null
  metaTitle: string | null
  schemaMarkup: string | null
  metaDescription: string | null
}

export interface ISeoPage {
  id: number
  no: string | null
  name: string | null
  nameInDutch: string | null
  title: string | null
  titleInDutch: string | null
  subTitle: string | null
  subTitleInDutch: string | null
  content: string | null
  subContent: string | null
  contentInDutch: string | null
  subContentInDutch: string | null
  milestone: string | null
  type: string // hoặc union type cụ thể nếu có danh sách
  media: string | null
  mediaId: number | null
  mediaMobile: string | null
  mediaMobileId: number | null
  thumbnail: string | null
  thumbnailId: number | null
  thumbnailMobile: string | null
  thumbnailMobileId: number | null
  mediaDescription: string | null
  mediaDescriptionInDutch: string | null
  metaData: MetaData
  mediaTitle: string | null
  createdAt: string // ISO date
  updatedAt: string // ISO date
}

export interface IJobQuery {
  page?: number
  limit?: number
  search?: string
  status?: number
  sort?: string
}
export interface IJobPosting {
  id: number
  title: string
  titleInDutch: string
  address: string
  description: string
  descriptionInDutch: string
  keyResponsibilities: string
  keyResponsibilitiesInDutch: string
  requirements: string
  requirementsInDutch: string
  whatWeOffer: string
  whatWeOfferInDutch: string
  dateExpired: string // ISO date
  type: string
  status: number
  publishedDate: string // ISO date
  updatedAt: string // ISO date
  createdAt: string // ISO date
  deletedAt: string | null
}
